const getTitleConfig = (contract) => {
    return {
        title: "Title", 
        taskKey: "title", 
        subText: 'Title company should provide title documents for you review', 
        due: `Record Title Objection Deadline: ${contract?.data?.dateFields?.record_title_objection_deadline?.date}`, 
        subSteps: [ 
            {
            title: <>Upload Title  <small>(Optional)</small></>, 
            subText: ["You can upload your title and have Shishito's AI review it for you"],
            taskKey: "uploadReport",
            actionTexts: ["Upload"],
            type: "upload"
            },
            {
            title: <div className="inline-flex gap-2">AI Analysis of Title Report <small>(Optional)</small></div>,
            subText: "Analyze your Title Report using Shishito AI. This will help you summarize the report and prepare for next steps.",
            taskKey: "titleAnalyze",
            actionTexts: ["Analyze"]
            }, 
            {
            title: "Title Insurance", 
            subText: ["Review the proposed title insurance coverage and consider whether you need additional endorsements based on your intended use of the property"],
            taskKey: "titleInsurance",
            actionTexts: ["Complete"]
            }, 
            {
            title: "Survey Review", 
            subText: ["If needed, consider ordering or reviewing an existing survey and verify property boundaries"],
            taskKey: "titleSurveyReview",
            actionTexts: ["Complete"]
            }, 
            {
            title: <>Title Objection <small>(Optional)</small></>, 
            taskKey: "generateTitleObjection",
            subText: "If anything stands out in the title you can generate a title objection.",
            actionTexts: ["Generate"]
            }, 
            {
            title: <>Post Objection <small>(Optional)</small></>,
            taskKey: "postTitleObjection",
            subText: "Options after generating an objection.",
            actionTexts: ["Withdraw", "Terminate"]
            },
        ]  
  };
};
  
export default getTitleConfig;
  